import(/* webpackMode: "eager" */ "/tmp/8def6f205ac95f1/src/app/page.tsx");
